import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { PrivilegesModules } from '@core/privileges/privileges-modules';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.programs.head'),
        url: RouteEntity.Root + RouteEntity.Programs,
        objName: [PrivilegesModules.B2bLoad, PrivilegesModules.B2bPrtnr],
    },
    {
        mdId: 3,
        mdName: marker('modules.searchRider.head'),
        url: RouteEntity.Root + RouteEntity.SearchRider,
        objName: [PrivilegesModules.B2bRidersSearch],
    },
    {
        mdId: 2,
        mdName: marker('modules.addRider.head'),
        url: RouteEntity.Root + RouteEntity.AddRider,
        objName: [PrivilegesModules.B2bRiderAdd],
    },
    {
        mdId: 4,
        mdName: marker('modules.removeRider.head'),
        url: RouteEntity.Root + RouteEntity.RemoveRider,
        objName: [PrivilegesModules.B2bRiderAdd],
    },
];

export const thirdLevelMenu: { [key: string]: MenuItemsModel[] } = {
    programs: [
        {
            mdId: 1,
            mdName: marker('global.labels.uploads'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Programs +
                '/#id#/' +
                RouteEntity.Uploads,
        },
        {
            mdId: 3,
            mdName: marker('b2b.submenu.programs.invoices'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Programs +
                '/#id#/' +
                RouteEntity.Invoices,
        },
        {
            mdId: 4,
            mdName: marker('global.labels.info'),
            urlTemplate:
                RouteEntity.Root + RouteEntity.Programs + '/#id#/' + RouteEntity.Info,
        },
    ],
};
